module.exports = __webpack_public_path__ + "static/media/182.e4c10b2c.mp3";